import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { ControleFichierCsvDto } from "../../../dto/GenApi.iNotPaie.Dto/ControleFichierCsvDto";

@Component
export default class ModalImportCsv extends Vue {
	public isLoading = true;
	public listeVariables?: ParametreDto[];
	public variableSelectionnee?: ParametreDto;
	public fichierCsv?: File;
	public hasFile = false;
	public inclureContratsActifs = false;

	public mounted(): void {
		$(".import-space").bind("dragenter", function() {
			$(".import-space").addClass("file-hover");
		});

		$(".import-space").bind("dragleave", function() {
			$(".import-space").removeClass("file-hover");
		});
	}

	public init(): void {
		this.isLoading = true;
		this.resetFileInput();
		this.variableSelectionnee = undefined;
		this.fichierCsv = undefined;
		this.hasFile = false;

		ServicesFactoryInstance.ParametresService.getListeVariablesCsv(data => {
			this.listeVariables = data;
			this.trierListeVariables();
			this.$forceUpdate();
			this.isLoading = false;
		}, () => {
			this.isLoading = false;
		});
	}

	public trierListeVariables(): void {
		if (this.listeVariables === undefined || this.listeVariables === null) {
			return;
		}

		this.listeVariables.sort((a, b) => {
			// Compare d'abord par la propriété Libelle
			const libelleA = (a.Libelle || "").toLowerCase(); // Traitement des valeurs null ou undefined
			const libelleB = (b.Libelle || "").toLowerCase();

			let compareLibelle = libelleA.localeCompare(libelleB);

			if (compareLibelle === 0) {
				const libelleCourtA = (a.LibelleCourt || "").toLowerCase(); // Traitement des valeurs null ou undefined
				const libelleCourtB = (b.LibelleCourt || "").toLowerCase();

				compareLibelle = libelleCourtA.localeCompare(libelleCourtB);
			}

			if (compareLibelle === 0) {
				const complementA = (a.Complement || "").toLowerCase(); // Traitement des valeurs null ou undefined
				const complementB = (b.Complement || "").toLowerCase();

				return complementA.localeCompare(complementB);
			}

			return compareLibelle;
		});
	}

	public close(): void {
		this.resetFileInput();
		$("#modalImportCsv").modal("hide");
	}

	public controler(): void {
		if (!this.peutEnregistrer() || this.fichierCsv === undefined || this.variableSelectionnee === undefined) {
			return;
		}

		const formData = new FormData();
		formData.append(this.fichierCsv.name, this.fichierCsv);

		this.isLoading = true;
		ServicesFactoryInstance.VariableCsvService.controleFichierCsv(this.variableSelectionnee.Id, formData, retour => {
			this.gereMessageUtilisateur(retour);
			this.isLoading = false;
		}, () => {
			this.isLoading = false;
		});
	}

	public enregistrer(): void {
		if (!this.peutEnregistrer() || this.fichierCsv === undefined || this.variableSelectionnee === undefined) {
			return;
		}

		const formData = new FormData();
		formData.append(this.fichierCsv.name, this.fichierCsv);
		this.isLoading = true;
		ServicesFactoryInstance.VariableCsvService.uploadFichierCsv(this.variableSelectionnee.Id, formData, () => {
			this.isLoading = false;
			NotificationServiceInstance.SendSuccess("Le fichier CSV a correctement été importé");
			this.$emit("validate");
			this.close();
		}, () => {
			this.isLoading = false;
		});
	}

	public peutEnregistrer(): boolean {
		let peutEnregistrer = true;

		if (this.fichierCsv === undefined || this.fichierCsv === null) {
			NotificationServiceInstance.SendFailed("Vous devez sélectionner un fichier CSV");
			peutEnregistrer = false;
		}

		if (this.variableSelectionnee === undefined || this.variableSelectionnee === null) {
			NotificationServiceInstance.SendFailed("Vous devez sélectionner une variable");
			peutEnregistrer = false;
		}

		return peutEnregistrer;
	}

	public gereMessageUtilisateur(controleFichierCsv: ControleFichierCsvDto): void {
		const listeLignesEnErreur = controleFichierCsv.ListeVariablesCsv.filter(function(v: any) {
			return v.ListeErreurs != undefined && v.ListeErreurs.length > 0;
		});

		if ((controleFichierCsv.ListeErreursMajeures === undefined || controleFichierCsv.ListeErreursMajeures.length === 0) &&
			(listeLignesEnErreur === undefined || listeLignesEnErreur.length === 0)) {
			NotificationServiceInstance.SendSuccess("Aucune erreur n'a été détectée, le fichier CSV peut être envoyé");

			return;
		}

		let message = "Des <strong>erreurs</strong> ont été détectées.<br>";

		if (controleFichierCsv.ListeErreursMajeures != undefined &&
			controleFichierCsv.ListeErreursMajeures.length > 0) {
			message = this.feedTheMessage(message, "Contrôle global", controleFichierCsv.ListeErreursMajeures);
		}

		for (const ligneEnErreur of listeLignesEnErreur) {
			message = this.feedTheMessage(message, `Ligne ${ligneEnErreur.NumeroLigne} du fichier`, ligneEnErreur.ListeErreurs);
		}

		NotificationServiceInstance.SendWarning(message, 10);
	}

	public feedTheMessage(message: string, titre: string, listeErreurs?: string[]): string {
		if (listeErreurs != undefined && listeErreurs != null && listeErreurs.length > 0) {
			const accord = listeErreurs.length > 1 ? "s" : "";
			message = `${message}<strong>${titre} (${listeErreurs.length} erreur${accord}) :</strong><br>`;
			listeErreurs.forEach(m => {
				message = `${message}_${m}<br>`;
			});
		}

		return message;
	}

	public toggleInclureContratsActifs(): void {
		if (this.isLoading) {
			return;
		}

		this.inclureContratsActifs = !this.inclureContratsActifs;
	}

	public telecharger(): void {
		NotificationServiceInstance.SendInformation("Téléchargement du modèle CSV en cours");

		ServicesFactoryInstance.VariableCsvService.getModeleCsv(this.inclureContratsActifs, (r: Blob) => {
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(r, "Modele_Import.csv");
			} else {
				  const link = document.createElement("a");
				document.body.appendChild(link);

				link.href = window.URL.createObjectURL(r);
				link.download = "Modele_Import.csv";
				link.click();

				NotificationServiceInstance.SendSuccess("La récupération du modèle CSV s'est correctement déroulée !");
			}
		});
	}

	public catchFile(e: any): void {
		$(".import-space").removeClass("file-hover");
		const file = e.srcElement.files[0];

		if (file === undefined || file === null || (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel")) {
			NotificationServiceInstance.SendFailed("Le fichier selectionné doit être un fichier CSV.");
			this.resetFileInput();

			return;
		}

		this.fichierCsv = file;
		this.hasFile = true;
		$(".import-space").addClass("import-disabled");

		this.$forceUpdate();
	}

	public resetFileInput(): void {
		$(".import-input").val("");
		$(".import-space").removeClass("import-disabled");
		this.fichierCsv = undefined;
		this.hasFile = false;
	}
}



// WEBPACK FOOTER //
// ./src/components/saisieDesVariables/modalImportCsv/modalImportCsv.ts